<template>
  <div class="chart" ref="mychart" :style="{ height: height, width: width }"></div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name: "ShouliChart",
  props: {
      width: {
          type: String,
          default: '980px'
      },
      height: {
          type: String,
          default: '224px'
      },
      dataList:{
          type: Array,
          default: () => []
      }
  },
  data() {
      return {
          chart: null
      }
  },
  watch: {
      dataList(){
          this.initChart()
      }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.mychart);
      this.chart.setOption({
        legend: {
          orient: 'vertical',
          top: 'middle',
          right: 60,
          padding: [30,0,30,0],
          itemGap: 16,
          itemWidth: 14,
          itemHeight: 14,
          textStyle: {
            color: '#fff',
            fontSize: 14,
            lineHeight: 10,
            padding: [0,10,0,8],
          },
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '58%'],
            center: ['30%', '50%'],
            data: this.dataList.map(obj => ({value: obj.total,name: obj.name, accept: obj.accept, complete: obj.complete, rate: obj.rate})),
            clockwise: false, //饼图的扇区是否是顺时针排布
            startAngle: 10,  //起始角度
            label: {
              show: true,
              position: 'outside',
              color: 'inherit',
              fontSize: 10,
              //backgroundColor: '#031843',
              distanceToLabelLine: 20,
              formatter: function (item) {
                return '已受理：' + item.data.accept + '\n办结量：' + item.data.complete + '\n办结率：' + item.data.rate + '%';
              },
            },
            labelLine: {
              show: true,
              length2: 80,
            },
            labelLayout: {
              hideOverlap: false, // 自动隐藏重叠标签
              //moveOverlap: 'shiftY', // 重叠时垂直移动
              draggable: true,   // 允许拖动标签
              //align: 'left',     // 对齐方式
              //verticalAlign: 'middle',
            }
          }
        ]
      })
    },
  },
}
</script>
<style scoped>
.chart{
  position: relative;
}
.chart::after{
  content: '';
  position: absolute;
  left: 30%;
  top: 50%;
  transform:translate(-50%,-50%);
  width: 191px;
  height: 191px;
  background: url("~@/assets/image/chart-bg1.png") no-repeat center;
}
</style>